import { Component, OnInit, Input, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageConfigurationService } from '../ph-bhp-feature-package-configuration.service';
import { GeneralSettings } from '../Models/GeneralSettings';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription, queueScheduler, scheduled } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { TranslationKeys } from 'ph-bhp-localization';
import { combineLatest } from "rxjs/index";

@Component({
  selector: 'app-ph-bhp-configure-general',
  templateUrl: './ph-bhp-configure-general.component.html',
  styleUrls: ['./ph-bhp-configure-general.component.css']
})
export class PhBhpConfigureGeneralComponent implements OnInit, OnDestroy {

  submitted = false;
  institutions: any;
  InstitutionsList: [any];
  itemChange: boolean = false;
  enablePhase2: boolean = false;
  subscription: Subscription;
  packageSubscription: Subscription;
  userData: any;
  selectedInstitution
  modalRef: BsModalRef;
  generalDetails: any;
  searchText;
  isDisabledState: boolean = false;
  institutionID;
  generalSettingID: number;
  packageID: number;
  consumptionConfigs: any[];
  currentYear: number;
  nextYear: number;
  consConfig: any;
  nextConsConfig: any;
  nextConsumptionConfChanged: boolean = false;

  settingsFormGroup = new UntypedFormGroup({
    period: new UntypedFormControl(''),
    nextPeriod: new UntypedFormControl(''),
    nextAmountMeasured: new UntypedFormControl(''),
    nextUnitMeasured: new UntypedFormControl(''),
    amountMeasured: new UntypedFormControl(''),
    KHCode: new UntypedFormControl(''),
    ConsumerKey: new UntypedFormControl(''),
    CHCUsername: new UntypedFormControl(''),
    CHCPassword: new UntypedFormControl(''),
    HandKissSurveillance: new UntypedFormControl(false),
    professionalSubcategory: new UntypedFormControl(false),
    recordingAseptic: new UntypedFormControl(false),
    enableHandWashing: new UntypedFormControl(false),
    unitMeasured: new UntypedFormControl(''),
    enableHAITracking: new UntypedFormControl(false),
    noSterility: new UntypedFormControl(true)
  });
  selected;
  myInstitutions = new UntypedFormGroup({
    selectedIns: new UntypedFormControl()
  });
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(private service: PHBHPFeaturePackageConfigurationService, private listservice: PHBHPListApiService, private layoutService: PHBHPLayoutPackageService, private modalService: BsModalService, public config: AppConfig) { }

  ngOnInit() {

    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID
      this.institutions = this.config.institutions;
      this.OnInstitutionsChanges()
      this.getSettings(this.institutionID);
    }
    this.packageID = this.layoutService.packageID;
    this.packageSubscription = this.layoutService.packageIDSubject.asObservable().subscribe((res) => {
      this.packageID = this.layoutService.packageID;
    });
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.institutionID = this.layoutService.institutionID
      this.institutions = this.config.institutions;
      this.getSettings(this.institutionID);
      this.OnInstitutionsChanges()
    });
    this.currentYear = new Date().getFullYear();
    this.nextYear = this.currentYear + 1;
  }
  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
    if (this.packageSubscription)
      this.packageSubscription.unsubscribe();
  }
  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      this.itemChange = true;
      var roleId = this.config.userData.roleName.roleId;
      this.service.getInstitutionsbyId(this.institutions, roleId).subscribe((res: any) => {
        this.InstitutionsList = res;
        if (this.layoutService.institutionID) {
          this.institutionID = this.layoutService.institutionID;
        } else {
          if (res.length > 0) {
            this.institutionID = res[0].institution.institutionID;
          }
        }

        this.onInstitutionChange(this.institutionID);
      })
    }
  }
  onInstitutionChange(value) {
    if (this.InstitutionsList) {
      this.layoutService.institutionID = value;
      this.layoutService.institutionIDSubject.next(value);
      var institution = this.InstitutionsList.find(x => x.institution.institutionID === value).institution
      this.packageID = institution.packageID;
      this.selected = institution.institutionID;
      this.selectedInstitution = institution.institutionName;
    }
  }
  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }
  openmodal(template: TemplateRef<any>) {
    this.myInstitutions.patchValue({
      selectedIns: this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' }));
  }

  getSettings(institutionid) {
    var isNoSterility
    this.layoutService.showLoader = true;
    this.listservice.getInstitutionsbyId(this.config.institutions, this.config.userData.roleName.roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      if (this.layoutService.institutionID) {
        this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === institutionid).institution.institutionName;
      }
      isNoSterility = this.InstitutionsList.find(x => x.institution.institutionID === institutionid).institution.isNoSterility;
      this.layoutService.showLoader = false;
    });

    this.service.getConfigDetails(institutionid).subscribe((res: GeneralSettings) => {
      this.generalDetails = res;
      this.generalSettingID = res.generalSettingID;
      this.consumptionConfigs = res.consumptionConfigs;

      this.consConfig = res.consumptionConfigs.find(conf => conf.year == this.currentYear) || {};
      this.nextConsConfig = res.consumptionConfigs.find(conf => conf.year == (this.currentYear + 1)) || {};

      if (Object.keys(this.nextConsConfig).length == 0 && !this.consConfig.isConsumptionEntered) {
        this.nextConsConfig = this.consConfig;
        this.nextYear = this.currentYear;
      }

      this.settingsFormGroup.patchValue({
        period: this.consConfig.period,
        nextPeriod: this.nextConsConfig.period ? this.nextConsConfig.period : this.consConfig.period,
        KHCode: res.khCode,
        ConsumerKey: res.consumerKey,
        CHCUsername: res.chcUsername,
        CHCPassword: res.chcPassword,
        amountMeasured: this.consConfig.amountMeasured,
        nextAmountMeasured: this.nextConsConfig.amountMeasured ? this.nextConsConfig.amountMeasured : this.consConfig.amountMeasured,
        unitMeasured: this.consConfig.unitOfMeasure,
        nextUnitMeasured: this.nextConsConfig.unitOfMeasure ? this.nextConsConfig.unitOfMeasure : this.consConfig.unitOfMeasure,
        HandKissSurveillance: res.enableHandKissSurveillance,
        professionalSubcategory: res.enableProfessionalSubCategory,
        recordingAseptic: res.enableAsepticSubTask,
        enableHAITracking: res.enableHAITracking,
        noSterility: isNoSterility,
        enableHandWashing: res.enableHandWashing,
      })
      this.isDisabledState = this.consConfig.isConsumptionEntered
    });
  }


  saveSettings() {
    this.userData = this.config.userData;
    this.submitted = true;
    this.nextConsumptionConfChanged = false;

    if (this.settingsFormGroup.invalid) {
      return false;
    }

    let generalSettingsUpdateObservable;
    let noSterilityUpdateObservable;
    let consumptionConfigUpdateObservable;
    let handwashConfigurationChanged: string = "";
    if (this.generalSettingID == 0) {
      this.generalDetails = {
        khCode: this.settingsFormGroup.value.KHCode ,
        consumerKey: this.settingsFormGroup.value.ConsumerKey,
        chcUsername: this.settingsFormGroup.value.CHCUsername,
        chcPassword: this.settingsFormGroup.value.CHCPassword,
        consumptionPeriod: this.settingsFormGroup.value.nextPeriod,
        consumptionMeasuredIn: this.settingsFormGroup.value.nextAmountMeasured,
        consumptionUnitOfMeasurement: this.settingsFormGroup.value.nextUnitMeasured,
        enableHandKissSurveillance: this.settingsFormGroup.value.HandKissSurveillance,
        enableProfessionalSubCategory: this.settingsFormGroup.value.professionalSubcategory,
        enableAsepticSubTask: this.settingsFormGroup.value.recordingAseptic,
        institutionId: this.institutionID,
        createdBy: this.userData.userId,
        enableHAITracking: this.settingsFormGroup.value.enableHAITracking,
        enableHandWashing: this.settingsFormGroup.value.enableHandWashing
      };
      generalSettingsUpdateObservable = this.service.createConfigDetails(this.generalDetails);

      // HHP-5081
      handwashConfigurationChanged = this.settingsFormGroup.value.enableHandWashing ? "HANDWASH_CONFIGURATION_DISABLED_ENABLED" : "HANDWASH_CONFIGURATION_ENABLED_DISABLED";
    } else {
      this.generalDetails.khCode = this.settingsFormGroup.value.KHCode;
      this.generalDetails.consumerKey = this.settingsFormGroup.value.ConsumerKey;
      this.generalDetails.chcUsername = this.settingsFormGroup.value.CHCUsername;
      this.generalDetails.chcPassword = this.settingsFormGroup.value.CHCPassword;
      this.generalDetails.consumptionPeriod = this.settingsFormGroup.value.nextPeriod;
      this.generalDetails.consumptionMeasuredIn = this.settingsFormGroup.value.nextAmountMeasured;
      this.generalDetails.consumptionUnitOfMeasurement = this.settingsFormGroup.value.nextUnitMeasured;
      this.generalDetails.enableHandKissSurveillance = this.settingsFormGroup.value.HandKissSurveillance;
      this.generalDetails.enableProfessionalSubCategory = this.settingsFormGroup.value.professionalSubcategory;
      this.generalDetails.enableAsepticSubTask = this.settingsFormGroup.value.recordingAseptic;
      this.generalDetails.updatedBy = this.userData.userId;
      this.generalDetails.enableHAITracking = this.settingsFormGroup.value.enableHAITracking;

      // HHP-5081
      // When IA changes HANDWASH from ENABLED to DISABLED for a specific institution
      if (this.generalDetails.enableHandWashing && !this.settingsFormGroup.value.enableHandWashing) {
        handwashConfigurationChanged = "HANDWASH_CONFIGURATION_ENABLED_DISABLED";
      // When IA changes HANDWASH from DISABLED to ENABLED for a specific institution
      } else if (!this.generalDetails.enableHandWashing && this.settingsFormGroup.value.enableHandWashing) {
        handwashConfigurationChanged = "HANDWASH_CONFIGURATION_DISABLED_ENABLED";
      } else {
        handwashConfigurationChanged = "HANDWASH_CONFIGURATION_NOT_CHANGED";
      }

      this.generalDetails.enableHandWashing = this.settingsFormGroup.value.enableHandWashing;
      generalSettingsUpdateObservable = this.service.updateConfigDetails(this.generalSettingID, this.generalDetails);
    }

    //check if all params of next period are setted
    if ((this.settingsFormGroup.value.nextPeriod && (!this.settingsFormGroup.value.nextAmountMeasured || !this.settingsFormGroup.value.nextUnitMeasured))
      || (this.settingsFormGroup.value.nextAmountMeasured && (!this.settingsFormGroup.value.nextPeriod || !this.settingsFormGroup.value.nextUnitMeasured))
      || (this.settingsFormGroup.value.nextUnitMeasured && (!this.settingsFormGroup.value.nextPeriod || !this.settingsFormGroup.value.nextAmountMeasured))) {
      this.layoutService.showError(this.layoutService.translateText(this.translationKeys.ErrorMessages.ConsumptionDataMissing));
      return false;
    } else if (this.settingsFormGroup.value.nextPeriod && this.settingsFormGroup.value.nextAmountMeasured && this.settingsFormGroup.value.nextUnitMeasured) {
      this.nextConsConfig.updatedBy = this.config.userData.userId,
        this.nextConsConfig.institutionID = this.layoutService.institutionID,
        this.nextConsConfig.period = this.settingsFormGroup.value.nextPeriod,
        this.nextConsConfig.amountMeasured = this.settingsFormGroup.value.nextAmountMeasured,
        this.nextConsConfig.unitOfMeasure = this.settingsFormGroup.value.nextUnitMeasured,
        this.nextConsConfig.year = this.isDisabledState ? this.currentYear + 1 : this.currentYear

      if (this.nextYear == (this.currentYear + 1)) {
        const next = this.consumptionConfigs.find(conf => conf.year == this.nextYear) || {};
        if (next.period != this.nextConsConfig.period || next.amountMeasured != this.nextConsConfig.amountMeasured || next.unitOfMeasure != this.nextConsConfig.unitOfMeasure) {
          this.nextConsumptionConfChanged = true;
        }
      }

      consumptionConfigUpdateObservable = this.service.updateConsumptionConfig(this.layoutService.institutionID, this.nextConsConfig);
    }

    noSterilityUpdateObservable = this.service.updateNoSterilityDetails(this.layoutService.institutionID, this.settingsFormGroup.value.noSterility ?? false);

    generalSettingsUpdateObservable = generalSettingsUpdateObservable || scheduled([null], queueScheduler);
    noSterilityUpdateObservable = noSterilityUpdateObservable || scheduled([null], queueScheduler);
    consumptionConfigUpdateObservable = consumptionConfigUpdateObservable || scheduled([null], queueScheduler);

    this.layoutService.showLoader = true;
    this.layoutService.showSubCategoryLink = this.settingsFormGroup.value.professionalSubcategory;
    combineLatest([generalSettingsUpdateObservable, noSterilityUpdateObservable, consumptionConfigUpdateObservable]).subscribe(([generalSettingsUpdateResponse, noSterilityUpdateResponse, consumptionConfResponse]) => {
      this.submitted = false;
      this.nextConsConfig = consumptionConfResponse;
      this.layoutService.showSuccess(this.layoutService.translateText('CONFIGURE.MESSAGE_SUCCESSFULLY.UPDATED.CONFIG_DETAILS'));
      if (handwashConfigurationChanged != "HANDWASH_CONFIGURATION_NOT_CHANGED") {
        var complianceData = {
          institutionId: this.layoutService.institutionID,
          complianceType: handwashConfigurationChanged,
          userId: this.userData.userId
        };

        console.log(complianceData);
        this.service.updateInstitutionCompliance(complianceData).subscribe((res) => {

        });
      }
    }, (error) => {
      this.layoutService.showError(this.layoutService.translateText('ERROR_MESSAGES.UNKNOWN'));
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  ngChangeCheckbox(HandKiss) {
    if (!HandKiss) {
      this.settingsFormGroup.get('KHCode').clearValidators();
      this.settingsFormGroup.get('KHCode').updateValueAndValidity();
      this.settingsFormGroup.get('ConsumerKey').clearValidators();
      this.settingsFormGroup.get('ConsumerKey').updateValueAndValidity();
      this.settingsFormGroup.get('CHCUsername').clearValidators();
      this.settingsFormGroup.get('CHCUsername').updateValueAndValidity();
      this.settingsFormGroup.get('CHCPassword').clearValidators();
      this.settingsFormGroup.get('CHCPassword').updateValueAndValidity();
    } else {
      this.settingsFormGroup.get('KHCode').setValidators([Validators.required]);
      this.settingsFormGroup.get('KHCode').updateValueAndValidity();
      this.settingsFormGroup.get('ConsumerKey').setValidators([Validators.required]);
      this.settingsFormGroup.get('ConsumerKey').updateValueAndValidity();
      this.settingsFormGroup.get('CHCUsername').setValidators([Validators.required]);
      this.settingsFormGroup.get('CHCUsername').updateValueAndValidity();
      this.settingsFormGroup.get('CHCPassword').setValidators([Validators.required]);
      this.settingsFormGroup.get('CHCPassword').updateValueAndValidity();
    }
  }

  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  isMyHygieneSOPLicense(packageID) {
    return packageID == 1 || packageID == 3 || packageID == 5 || packageID == 7;
  }

  isObserveLicense(packageID) {
    return packageID == 2 || packageID == 3 || packageID == 6 || packageID == 7;
  }

  isHygieneCheckLicense(packageID) {
    return packageID == 4 || packageID == 5 || packageID == 6 || packageID == 7;
  }
}
